/**
 * The one hotkey registry (03 §5.14). The `?` sheet reads
 * it, so a shortcut that exists is a shortcut that is documented.
 */
export type Hotkey = { keys: string; label: string; group: 'Global' | 'Navigate' | 'Lists' | 'Workspace' }

export const HOTKEYS: Hotkey[] = [
  { keys: 'Shift+?', label: 'Keyboard shortcuts', group: 'Global' },
  { keys: 'Escape', label: 'Close', group: 'Global' },
  { keys: 'g h', label: 'Go home', group: 'Navigate' },
  { keys: 'g i', label: 'Go to inbox', group: 'Navigate' },
  { keys: 'g a', label: 'Go to activity', group: 'Navigate' },
  { keys: 'g s', label: 'Go to servers', group: 'Navigate' },
  { keys: 'g u', label: 'Go to usage', group: 'Navigate' },
  { keys: 'g p', label: 'Go to people', group: 'Navigate' },
  { keys: 'j', label: 'Next row', group: 'Lists' },
  { keys: 'k', label: 'Previous row', group: 'Lists' },
  { keys: 'Enter', label: 'Open', group: 'Lists' },
  { keys: '1', label: 'Chat', group: 'Workspace' },
  { keys: '2', label: 'Terminal', group: 'Workspace' },
  { keys: '3', label: 'Log', group: 'Workspace' },
  { keys: '$mod+Shift+d', label: 'Diff', group: 'Workspace' },
  { keys: '$mod+Shift+c', label: 'Checks', group: 'Workspace' },
  { keys: '$mod+Shift+p', label: 'PR', group: 'Workspace' },
  { keys: '$mod+.', label: 'Stop session', group: 'Workspace' },
]

export function prettyKeys(keys: string): string {
  const mac = typeof navigator !== 'undefined' && /Mac/.test(navigator.platform)
  return keys
    .replace('$mod', mac ? '⌘' : 'Ctrl')
    .replace('Shift+', '⇧')
    .replace('Escape', 'Esc')
    .replace(/\+/g, '')
}

/** Hotkeys must not fire while someone is typing into a field or the terminal. */
export function isTypingTarget(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false
  return t.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName) || !!t.closest('.xterm')
}
